export default __webpack_public_path__ + "static/media/1617 utensils top.444d0540.png";